module.exports = __webpack_public_path__ + "static/img/remen.f6db533e.png";